const paths = {
  pool: '/orders/pool',
  ordersIntegrations: '/orders/integrations',
  dispatch: '/orders/dispatch'
};

export default paths;
